<script setup lang="ts">
import { useDisplayName } from '@/composables/useDisplayName';
import { IGenericPerson } from 'common/utils/name.utils';
import { computed } from 'vue';

const props = defineProps<{
  person: IGenericPerson;
  emailFallback?: boolean;
}>();

const { getUserDisplayName, getUserDisplayNameOrEmail } = useDisplayName();

const text = computed(() =>
  props.emailFallback ? getUserDisplayNameOrEmail(props.person) : getUserDisplayName(props.person),
);
</script>

<!-- Renders a bare text node so it can be dropped into any markup (incl. truncation containers). -->
<template>{{ text }}</template>
